var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconButtonView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-button-view",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_11734",
    "data-name": "Rettangolo 11734",
    width: 37,
    height: 37,
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Sottrazione_2",
    "data-name": "Sottrazione 2",
    d: "M17641.779,21442.5a11.851,11.851,0,0,1-7.373-3.084,20.294,20.294,0,0,1-3.16-3.27l-.006-.01a.71.71,0,0,1,0-.828c.488-.652,4.934-6.359,10.539-6.359,5.621,0,10.059,5.705,10.545,6.357a.7.7,0,0,1,0,.83l0,.01a20.252,20.252,0,0,1-3.162,3.27A11.862,11.862,0,0,1,17641.779,21442.5Zm.191-10.621a3.588,3.588,0,1,0,3.611,3.588A3.6,3.6,0,0,0,17641.971,21431.881Z",
    transform: "translate(-17623.109 -21416.949)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonView);
export default __webpack_public_path__ + "static/media/icon-button-view.398b40cb7dc357d1517c4ad1334d3b89.svg";
export { ForwardRef as ReactComponent };